export const SET_SOURCE_SEARCH = 'setCopayEPASourceSearch';
export const SET_SOURCE_GET = 'setCopayEPASourceGet';
export const SET_SOURCE_FILTERS_GET = 'setCopayEPASourceFilterGet';
export const SET_SOURCE_FILTER_ADD = 'setCopayEPASourceFilterAdd';
export const SET_SOURCE_FILTER_REMOVE = 'setCopayEPASourceFilterRemove';
export const SET_SOURCE_FILTER_SAVE = 'setCopayEPASourceFilterSave';
export const SET_SOURCE_PHARMACY_ADD = 'setCopayEPASourcePharmacyAdd';
export const SET_SOURCE_PHARMACY_REMOVE = 'setCopayEPASourcePharmacyRemove';
export const SET_SOURCE_PHARMACY_SAVE = 'setCopayEPASourcePharmacySave';
export const SET_SOURCE_BUSY = 'setCopayEPASourceBusy';
export const SET_SOURCE_SEARCH_BUSY = 'setCopayEPASourceSearchBusy';
export const SET_CURRENT_SETTING = 'setCopayEPACurrentSettingss';



// WEBPACK FOOTER //
// ./src/store/copay-epa-source/mutations.type.js